function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "2682842---breeze-fast-speed-weather-wind-windy",
  transform: "translate(3.000000, 2.000000)",
  strokeWidth: 5
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,59.5725105 L65.4936276,59.5725105 C72.9529911,59.5725105 79,65.6166664 79,73.0725105 L79,73.0725105 C79,80.5283547 72.9529911,86.5725105 65.4936276,86.5725105",
  id: "Path",
  stroke: "#A5A9AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.3239437,0.57251054 C84.1155973,0.57251054 88,4.37809017 88,9.07251054 L88,9.07251054 C88,13.7669309 84.1155973,17.5725105 79.3239437,17.5725105 L0,17.5725105",
  id: "Path",
  stroke: "#A5A9AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77,40.5725105 L107.487805,40.5725105 C111.084391,40.5725105 114,43.4881196 114,47.0847057 L114,47.0847057 C113.986565,50.6717631 111.074887,53.5725105 107.487805,53.5725105",
  id: "Path",
  stroke: "#B9C1C6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42,39.5725105 L62,39.5725105",
  id: "Path",
  stroke: "#A5A9AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,39.5725105 L27,39.5725105",
  id: "Path",
  stroke: "#B9C1C6",
  fill: "#D8D8D8"
})));

function SvgAirFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "92px",
    viewBox: "0 0 120 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2682842 - breeze fast speed weather wind windy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirFlow);
export default __webpack_public_path__ + "static/media/airFlow.93b49bb5.svg";
export { ForwardRef as ReactComponent };